module.exports = __webpack_public_path__ + "static/media/goals-and-targets-roa.dec455af.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/goals-and-targets-roa.mp4
// module id = 562
// module chunks = 0